import { TurnTrackingPartyType } from '~/types/TurnTracking';
import { Uuid } from '~/types/Uuid';

export const getTurnTrackingParties = async ({
  // TODO: remove this once we have parties setup upstream
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  workflowId,
}: {
  workflowId: Uuid;
}): Promise<TurnTrackingPartyType[]> => {
  return [
    {
      id: '11111111-1111-1111-1111-111111111111',
      name: 'Internal',
      type: 'company',
    },
    {
      id: '22222222-2222-2222-2222-222222222222',
      name: 'External',
      type: 'counter',
    },
  ];
};
